import { render, staticRenderFns } from "./ModalPrescription.vue?vue&type=template&id=2e7e8812"
import script from "./ModalPrescription.vue?vue&type=script&lang=js"
export * from "./ModalPrescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports